import { Messages } from '../../codegen/Localize';
import { CommonErrorCode, MetricErrorCode } from '../../ts/helpers/ErrorCodes';
import { MetricContentType } from '../models/MetricContentType';
import { IMetricInfo } from '../models/IMetricInfo';
import { IErrorItem } from '../../commonInfra/contentActions/MultipleItemResult';
import { ContentUrlForItem } from '../../ts/services/ContentUrl';
import { IErrorDetail } from '../../commonInfra/contentActions/ActionMessages';

export namespace MetricErrors {

  export function errorDetailsFor(metricErrorItem: IErrorItem<IMetricInfo>): IErrorDetail {
    return {
      itemName: metricErrorItem.item.name,
      itemUrl:
          metricErrorItem.error.code === MetricErrorCode.MetricNotFound
          ? null
          : ContentUrlForItem(metricErrorItem.item, MetricContentType),
      errorMessage: this.errorMessageFor(metricErrorItem)
    };
  }

  export function errorMessageFor(errorItem: IErrorItem<IMetricInfo>) {
    const metric = errorItem.item;
    switch (errorItem.error.code) {
      case MetricErrorCode.MetricNotFound:
        return Messages.errorMetricNotFound({METRIC_NAME: metric.name});
      case MetricErrorCode.MetricNameAlreadyExistsInDestinationProject:
        return Messages.errorMetricNameAlreadyExistsInDestinationProject();

      // Permissions errors
      case MetricErrorCode.MetricMoveInsufficientPermissionsOnMetric:
        return Messages.errorMetricMoveInsufficientPermissions();
      case CommonErrorCode.CallingUserInsufficientPermissions:
        return Messages.errorMetricInsufficientPermissions();

      default:
        return Messages.errorUnknown();
    }
  }
}
